module.exports = __webpack_public_path__ + "img/dieqrcode.e7be1347.png";